import React from 'react';

import { QueryClient, QueryClientProvider } from '@eika-infrastruktur/react-query';
import { loadContainers } from '@eika-infrastruktur/render';
import { SkeletonThemeProvider } from '@eika/skeleton';

import { ArchiveApp } from './containers/ArchiveApp';
import { TasksApp } from './containers/TasksApp';
import { Config, defaultConfig } from './default-config';
import getCssVariableValue from './utils/getCssVariableValue';

const globalCssNamespace = 'no-eika-infra-esignering-web';

export const REPO_NAMESPACE = 'infra.esignering-web';

const staleTime = 60 * 60 * 5; // 5 min
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime,
            retry: 1,
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: false,
            retryOnMount: false,
        },
    },
});

const renderApp =
    (MyApp: React.ComponentType, appDefaultConfig: Config = defaultConfig) =>
    (namespace: string): void => {
        loadContainers(
            `${REPO_NAMESPACE}.${namespace}`,
            () => (
                <React.StrictMode>
                    <QueryClientProvider client={queryClient}>
                        <SkeletonThemeProvider
                            baseColor={getCssVariableValue('--neutral-background')}
                            highlightColor={getCssVariableValue('--card-background-light')}
                        >
                            <div className={globalCssNamespace}>
                                <MyApp />
                            </div>
                        </SkeletonThemeProvider>
                    </QueryClientProvider>
                </React.StrictMode>
            ),
            appDefaultConfig,
        );
    };

const apps: Record<string, (namespace: string) => void> = {
    'signing-room': renderApp(TasksApp),
    archive: renderApp(ArchiveApp),
};

Object.keys(apps).forEach((key: string) => apps[key](key));
